import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from "vue";
import { RouteLocationPathRaw, RouteLocationNamedRaw } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterButton',
  props: {
  to: {
    type: Object as PropType<RouteLocationPathRaw | RouteLocationNamedRaw>,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  type: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const type = computed(() => {
  let c = "";

  switch (props.type) {
    case "primary":
      c = "bg-primary active:bg-blue-600 hover:bg-blue-600 border-primary text-white";
      break;
    case "secondary":
      c = "border border-primary text-primary bg-white active:bg-primary hover:bg-primary hover:text-white";
      break;
    case "danger":
      c = "bg-danger hover:bg-red-600 border-danger text-black";
      break;
  }

  return c;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.disabled ? 'span' : 'router-link'), {
    to: __props.to,
    class: _normalizeClass([
      __props.disabled ? 'cursor-not-allowed border-blue-300 bg-blue-300 hover:bg-blue-300 hover:border-blue-300' : '',
      _unref(type),
      'capitalize  border rounded whitespace-nowrap focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-2 h-10 block w-fit',
    ])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["to", "class"]))
}
}

})